import daterangepicker from 'daterangepicker';
window.daterangepicker = daterangepicker;
import 'daterangepicker/daterangepicker.css'
